import {Address} from "@models/address.interface";

export const LOAD_ADDRESSES_SUCCESS = 'LOAD_ADDRESSES_SUCCESS';
export const LOAD_FILTERED_ADDRESSES_SUCCESS = 'LOAD_FILTERED_ADDRESSES_SUCCESS';
export const LOAD_ADDRESSES = 'LOAD_ADDRESSES';
export const ADD_ADDRESS = 'ADD_ADDRESS';
export const EDIT_ADDRESS = 'EDIT_ADDRESS';
export const ADD_EDIT_ADDRESS = 'ADD_EDIT_ADDRESS';
export const REMOVE_ADDRESSES = 'REMOVE_ADDRESSES';
export const REMOVE_ADDRESS_FAIL = 'REMOVE_ADDRESS_FAIL';
export const SET_ACTIVE_ADDRESS_SEARCH = 'SET_ACTIVE_ADDRESS_SEARCH';

export class LoadAddresses {
  readonly type = LOAD_ADDRESSES;
  constructor(public payload: {
    current_page_size: number,
    current_page: number,
    activeSearch?: string,
  }) {}
}

export class LoadAddressesSuccess {
  readonly type = LOAD_ADDRESSES_SUCCESS;
  constructor(public payload: {
    current_page_size: number,
    current_page: number,
    data: Address[],
    total: number;
  }) {}
}


export class LoadFilteredAddressesSuccess {
  readonly type = LOAD_FILTERED_ADDRESSES_SUCCESS;
  constructor(public payload: {
    current_page_size: number,
    current_page: number,
    data: Address[],
    total: number;
    activeSearch: string
  }) {}
}

export class AddAddress {
  readonly type = ADD_ADDRESS;
  constructor(public payload: Address) {}
}

export class EditAddress {
  readonly type = EDIT_ADDRESS;
  constructor(public payload: Address) {}
}

export class AddEditAddressFail {
  readonly type = ADD_EDIT_ADDRESS;
}

export class RemoveAddresses {
  readonly type = REMOVE_ADDRESSES;
  constructor(public payload: {ids: number[], current_page: number, current_page_size: number}) {}
}

export class RemoveAddressFail {
  readonly type = REMOVE_ADDRESS_FAIL;
}

export class SetActiveAddressesSearch {
  readonly type= SET_ACTIVE_ADDRESS_SEARCH;
  constructor(public payload: {
    current_page_size: number,
    current_page: number,
    activeSearch: string
  }) {}
}

export type AddressPayload = {
  current_page_size: number,
  current_page: number,
  activeSearch: string,
  ids: number[],
  data: Address[],
  total: number;
};



// WEBPACK FOOTER //
// ./src/app/store/actions/addresses.action.ts